import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Globe, Loader2 } from "lucide-react";

import { formatApiError } from "@/api/client";
import { useAuth } from "@/context/AuthContext";

export function PlatformTenantBanner() {
    const { t } = useTranslation();
    const { me, activeMembership, exitTenant } = useAuth();
    const nav = useNavigate();
    const [busy, setBusy] = useState(false);
    if (!me?.user?.is_platform_owner || !activeMembership?.platform_access) return null;
    const exit = async () => {
        setBusy(true);
        try { await exitTenant(); nav("/platform"); }
        catch (e: any) { toast.error(formatApiError(e)); }
        finally { setBusy(false); }
    };
    return (
        <div data-testid="platform-tenant-banner" className="flex flex-wrap items-center gap-3 px-6 py-2 text-sm"
             style={{ background: "var(--info-bg)", color: "var(--info-fg)", borderBottom: "1px solid var(--border)" }}>
            <Globe size={16} className="shrink-0" />
            <span className="flex-1 min-w-[200px]">{t("platform_view.inside_tenant", { name: activeMembership.tenant.name })}</span>
            <button type="button" onClick={exit} disabled={busy} data-testid="platform-tenant-exit-btn"
                    className="inline-flex items-center gap-1.5 rounded-md px-3 py-1 text-xs font-medium border disabled:opacity-60"
                    style={{ borderColor: "var(--info-fg)", color: "var(--info-fg)" }}>
                {busy && <Loader2 size={12} className="animate-spin" />}{t("platform_view.exit_tenant")}
            </button>
        </div>
    );
}
